module.exports = "/_next/static/images/fallback-image-16-9-eaa0aba7a536c27bcdf9caee94ca26cb.png";